import axios from "axios";
import {KEY_LOCALSTORAGE} from "src/app/modules/auth/core/_consts";
import {localStorageItem} from "src/app/modules/utils/LocalStorage";
import {DocumentKeys, THONG_TIN_BENH_AN_CONFIG} from "../constants/BenhAn";
import {APP_CONFIGURATION_KEYS} from "src/app/modules/utils/Constant";
import {OctResponse} from "src/app/modules/models/OctResponse";
import {PagingParams} from "src/app/modules/utils/ParamsUtils";

const INPATIENT_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL]
  || process.env.REACT_APP_INPATIENT_API_URL;
const API_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL]
  || process.env.REACT_APP_INPATIENT_API_URL;
export const REPORT_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.REPORT_URL]
  || process.env.REACT_APP_REPORT_API_URL;

export const EMR_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.EMR_URL];

const API_FIFTEEN_DAYS_TREATMENT = INPATIENT_URL + "/treatment-fifteen-days";
const API_VITAL_SIGNS = INPATIENT_URL + "/vital-signs";
const API_TREATMENT_SHEETS = INPATIENT_URL + "/treatment-sheets";
const API_CARE_CARD = INPATIENT_URL + "/care-card";
const API_CARE_PLAN = INPATIENT_URL + "/care-plan";
const API_EXPORT = INPATIENT_URL + "/download";
const API_REPORT = `${REPORT_URL}/rest/reports/run`;

type IParamsGetDsPhieu = {
  patientId: string,
  visitId?: string,
  medicalRecordCode: string,
  orderId?: string,
};

type IParamsInPhieu = {
  keyConfig: DocumentKeys,
  exportId: string,
  parameters: {
    name: string,
    value: string
  }[],
  fileType: string,
};

// Get json form
export const getJsonGenerateFormNoiTru = async (code: string, baseURL?: string) => {
  let url = (baseURL || INPATIENT_URL) + `/term-models/${code}/model-json`;
  return axios.get(url);
};

// Cay benh an
export const getTreeDataBenhAn = async (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_URL + `/medical-record-category/tree-list`;
  return axios.get(url, {params});
};

// Phieu dieu tri
export const getDsPhieuDieuTri = (params: IParamsGetDsPhieu) => {
  let url = API_TREATMENT_SHEETS + "/search";
  return axios.get(url, { params });
}

export const createPhieuDieuTri = (data: any) => {
  return axios.post(API_TREATMENT_SHEETS, data);
}

export const updatePhieuDieuTri = (data: any) => {
  return axios.put(API_TREATMENT_SHEETS, data);
}

export const getDetailPhieuDieuTri = (id: any) => {
  let url = API_TREATMENT_SHEETS + `/obs-complex/by-id/${id}`;
  return axios.get(url);
}

export const deletePhieuDieuTri = (id: any, params: any) => {
  let url = API_TREATMENT_SHEETS + `/${id}`;
  return axios.delete(url, { params });
}

// Phieu so ket 15 ngay
export const getDsPhieuSoKet15Ngay = (params: IParamsGetDsPhieu) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + "/search";
  return axios.get(url, { params });
}

export const createPhieuSoKet15Ngay = (data: any) => {
  return axios.post(API_FIFTEEN_DAYS_TREATMENT, data);
}

export const updatePhieuSoKet15Ngay = (data: any) => {
  return axios.put(API_FIFTEEN_DAYS_TREATMENT, data);
}

export const getDetailPhieuSoKet15Ngay = (id: any) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + `/obs-complex/by-id/${id}`;
  return axios.get(url);
}

export const deletePhieuSoKet15Ngay = (id: any, params: any) => {
  let url = API_FIFTEEN_DAYS_TREATMENT + `/${id}`;
  return axios.delete(url, { params });
}

// Theo doi dau hieu sinh ton
export const getDsPhieuTheoDoiDHST = (params: IParamsGetDsPhieu) => {
  let url = API_VITAL_SIGNS + "/search";
  return axios.get(url, { params });
}

export const createPhieuTheoDoiDHST = (data: any) => {
  return axios.post(API_VITAL_SIGNS, data);
}

export const updatePhieuTheoDoiDHST = (data: any) => {
  return axios.put(API_VITAL_SIGNS, data);
}

export const getDetailPhieuTheoDoiDHST = (id: any) => {
  let url = API_VITAL_SIGNS + `/${id}`;
  return axios.get(url);
}

export const deletePhieuTheoDoiDHST = (id: any, params: any) => {
  let url = API_VITAL_SIGNS + `/${id}`;
  return axios.delete(url, { params });
}

export const getPhieuTheoDoiDHSTGanNhat = (medicalRecordCode: any) => {
  let url = API_VITAL_SIGNS + `/obs-complex/previous/${medicalRecordCode}`;
  return axios.get(url);
}

//Phieu cham soc
export const getDsPhieuChamSoc = (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_CARE_CARD + "/search";
  return axios.post(url, params);
}

export const createPhieuChamSoc = (data: any) => {
  return axios.post(API_CARE_CARD, data);
}

export const updatePhieuChamSoc = (data: any) => {
  let url = API_CARE_CARD + `/${data?.id}`;
  return axios.post(url, data);
}

export const getDetailPhieuChamSoc = (id: any) => {
  let url = API_CARE_CARD + `/${id}`;
  return axios.get(url);
}

export const deletePhieuChamSoc = (id: any, params: any) => {
  let url = API_CARE_CARD + `/${id}`;
  return axios.delete(url, { params });
}

//Phieu cham soc ke hoach
export const getDsPhieuChamSocKH = (params: Partial<IParamsGetDsPhieu>) => {
  let url = API_CARE_PLAN + "/search";
  return axios.post(url, params);
}

export const createPhieuChamSocKH = (data: any) => {
  return axios.post(API_CARE_PLAN, data);
}

export const updatePhieuChamSocKH = (data: any) => {
  let url = API_CARE_PLAN + `/${data?.id}`;
  return axios.post(url, data);
}

export const getDetailPhieuChamSocKH = (id: any) => {
  let url = API_CARE_PLAN + `/${id}`;
  return axios.get(url);
}

export const deletePhieuChamSocKH = (id: any, params: any) => {
  let url = API_CARE_PLAN + `/${id}`;
  return axios.delete(url, { params });
}

//in phieu
export const inPhieuChamSoc = async (params: any) => {
  let url = API_EXPORT + "/care-card";
  return await axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const inPhieuTruyenDich = async (params: any) => {
  let url = API_EXPORT + "/infusion-monitoring";
  return await axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const inBienBanHoiChan = async (params: any) => {
  let url = API_EXPORT + "/consultation";
  return await axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const inBienBanHoiChanPhauThuat = async (params: any) => {
  let url = API_EXPORT + "/surgical-consultation";
  return await axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const inPhieuHoSoBenhAn = async (data: IParamsInPhieu) => {
  const { keyConfig, exportId, parameters, fileType } = data;
  let requestBody = {
    parameters,
    template: THONG_TIN_BENH_AN_CONFIG?.[keyConfig]?.TEMPLATE?.[fileType],
  };
  let url = API_REPORT + `/${exportId}`;
  return await axios.post<Blob>(url, requestBody, { responseType: 'blob' });
};

export const getTreatmentRecords = async (
  params: PagingParams & {
    treatmentId: string;
    termModelType: string;
  }
) => {
  const {data} = await axios.get<OctResponse<any>>(`${INPATIENT_URL}/treatment-records`, {
    params,
  });
  return data;
};

export const getTreatmentRecord = async (params: {
  treatmentId: string;
  termModelType: string;
}) => {
  const {treatmentId, termModelType} = params;

  const {data} = await axios.get<OctResponse<any>>(
    `${INPATIENT_URL}/treatment-records/${treatmentId}/${termModelType}`
  );
  return data;
};

export const getTreatmentRecordItem = async (params: { id: string }) => {
  const {id} = params;

  const {data} = await axios.get<OctResponse<any>>(`${INPATIENT_URL}/treatment-records/${id}`);
  return data;
};

export const createTreatmentRecord = async (params: {
  treatmentId: string;
  termModelType: string;
  [key: string]: any;
}) => {
  const {treatmentId, termModelType} = params;

  const {data} = await axios.post<OctResponse<any>>(
    `${INPATIENT_URL}/treatment-records/${treatmentId}/${termModelType}`,
    params
  );
  return data;
};

export const updateTreatmentRecord = async (params: { id: string; [key: string]: any }) => {
  const {id} = params;
  const {data} = await axios.put<OctResponse<any>>(
    `${INPATIENT_URL}/treatment-records/${id}`,
    params
  );
  return data;
};

export const deleteTreatmentRecord = async (params: { id: string }) => {
  const {id} = params;
  const {data} = await axios.delete<OctResponse<any>>(`${INPATIENT_URL}/treatment-records/${id}`);
  return data;
};

export const printTreatmentRecord = async (params: { termId: number; id: string }) => {
  const {termId, id} = params;
  return await axios.post(`${INPATIENT_URL}/treatment-records/export/${id}`, null, {
    params: {
      termId,
    },
    responseType: 'blob',
  });
};

export const getEMedicalRecordLink = async (params: {
	medicalRecordCode: string;
	system: string;
}) => {
	const { data } = await axios.post<OctResponse<any>>(`${EMR_URL}/emr/integration/send`, params);
	return data;
};